import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vsezuurgak: FaireBrandEntity = {
  token: "b_vsezuurgak",
  type: "brand",
  name: "Made in eatalia",
  avatarUrl:
    "https://cdn.faire.com/fastly/da9585e0cb7113e16eb3a6336e3cd6506ca1a607f3692ab7bf5c1097d7084161.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a05fd6f68ed3b74b5a03c75c47f89ee5ad698c98053ff214c49aef216bd1d961.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/da9585e0cb7113e16eb3a6336e3cd6506ca1a607f3692ab7bf5c1097d7084161.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a05fd6f68ed3b74b5a03c75c47f89ee5ad698c98053ff214c49aef216bd1d961.jpeg",
  location: "Glendale , NY, USA",
  minimumOrderDollars: 208,
  rating: 4.5,
  reviewCount: 34,
  isInsider: true,
  description:
    "Made in Eatalia is the best place to find imported, authentic Italian goods.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:51.797Z",
    importedBy: "entity-db-cli",
  },
};
